module.exports = __webpack_public_path__ + "img/mode_4.942a5070.png";